import React, { useEffect, useState } from "react";
import apiRequest from "../../../utils/ApiRequest/apiRequest.js";
import Image from "components/Elements/Image/Image.tsx";
import useMediaQueries from "../../../hooks/useMediaQueries.js";
import Adsense from "../../Reusable/Adsense/Adsense.js";
import CreatorCard from "./CreatorCard.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";

import "./CreatorHomePage.scss";

const CreatorHomePage = () => {
  const [creators, setCreators] = useState();
  const { getTextByKey, getLanguageCulture } = useContent();
  const { Desktop } = useMediaQueries();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCreators();
  }, []);

  const fetchCreators = async () => {
    const response = await apiRequest(
      "Creator",
      `ReactGetCreators?creatorCulture=${getLanguageCulture().substring(0, 2)}`
    );

    if (response) {
      setCreators(response.data);
      setLoading(false);
    }
  };

  const getCreators = () => {
    const tempCreators = creators.slice();
    if (tempCreators.length > 0) {
      let html = [];
      while (tempCreators.length > 0) {
        html.push(
          <div
            key={tempCreators[0]?.CreatePageUrl}
            className="creator-articles-row"
          >
            {tempCreators.splice(0, 3).map((creator, index) => {
              return (
                <CreatorCard
                  key={creator.CreatePageUrl + index}
                  creator={creator}
                />
              );
            })}
          </div>
        );
      }

      return html;
    }
  };

  //add empty alt and title to CoverImage
  return (
    <>
      <div className="image-wrapper">
        <Image
          name="creator-cover-img"
          ext="jpg"
          alt="Cover Picture"
          title="Cover Picture"
        />
        <h1 className="jumbomail-creator-text">{getTextByKey("jumbo-art")}</h1>
        <span className="jumbomail-creator-sub-text">
          {getTextByKey("jumbo-art-sub-text")}
        </span>
      </div>
      <Desktop>
        <Adsense bannerPosition="creator-left-side" />
      </Desktop>
      <Desktop>
        <Adsense bannerPosition="creator-right-side" />
      </Desktop>
      {!loading ? (
        <div className="creator-articles">{getCreators()}</div>
      ) : (
        <div className="loading-creator-container">
          <Image
            className="loader-animation-gif"
            name="preloader"
            ext="gif"
            alt=""
            title=""
          />
        </div>
      )}
    </>
  );
};

export default CreatorHomePage;
